import React from "react";

const StatusCard = (props) => {
    
    return(
        
        <div className={`block ${props.cardWidth} md:relative md:h-40 p-5 bg-white  rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 `}>
            <p className="font-normal text-3xl text-gray-700 dark:text-gray-400">{props.cardhead} </p>
            <h5 className={`mb-2 text-5xl font-bold tracking-tight text-gray-900 dark:${props.color}`}>{props.CardVal}</h5>
            {props.imgShow ? <img className="float-right h-20 md:absolute bottom-2 right-2" src={props.imgImage} alt="oo" /> : ''}
            {/* <img className="float-right h-20 md:absolute bottom-2 right-2" src="https://pngimg.com/d/recycle_bin_PNG45.png" alt="oo" /> */}
            {/* {props.closeToFillShow ? <p className="text-gray-500"><span className="text-xl font-bold text-gray-500">{props.closeToFillCount}</span> close to fill(>70%)</p>: ''} */}
            {/* <p className="text-gray-700"><span className="text-xl font-bold text-gray-600">3</span> close to fill(75%)</p> */}
        </div>

    )
}

export default StatusCard